import {useEffect} from 'react';

import type {AreaDispatcher} from './useAreas';
import type {TrackDispatcher} from './useTracks';
import type {WaypointDispatcher} from './useWaypoints';

interface UseTakeLocalURLPropsSelectionsOptions {
    selections: SelectionState[] | undefined;
    areaDispatcher: AreaDispatcher;
    trackDispatcher: TrackDispatcher;
    waypointDispatcher: WaypointDispatcher;
}

export default function useTakeLocalURLPropsSelectionsEffect({
    selections,
    areaDispatcher,
    trackDispatcher,
    waypointDispatcher,
}: UseTakeLocalURLPropsSelectionsOptions) {
    useEffect(() => {
        if (!selections) return;
        for (const selection of selections) {
            if (selection.type === 'area') {
                areaDispatcher({
                    type: 'takeLocal',
                    area: {properties: {id: selection.localId}},
                });
            } else if (selection.type === 'track') {
                trackDispatcher({
                    type: 'takeLocal',
                    track: {properties: {id: selection.localId}},
                });
            } else if (selection.type === 'waypoint') {
                waypointDispatcher({
                    type: 'takeLocal',
                    waypoint: {properties: {id: selection.localId}},
                });
            }
        }
    }, [areaDispatcher, trackDispatcher, selections, waypointDispatcher]);
}
